<template>
    <div>
<!--        <van-nav-bar-->
<!--                title="公司简介"-->
<!--                left-text=""-->
<!--                left-arrow-->
<!--                fixed-->
<!--                @click-left="back()"-->
<!--                v-if="show"-->
<!--        />-->

        <div class="searchwarp">

            <div class="van-cell-group van-hairline--top-bottom van-panel" style="border-bottom: 0">
<!--                <div class="van-cell van-panel__header">-->
<!--                    <div class="van-cell__title">-->
<!--                        <span>联系我们</span>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="van-panel__content" style="line-height: 1.8">
                    <div>
                        <p><img src="../../assets/image/contactus.jpg" width="100%"/></p>
                        <dl>
                            <dt>天津市瑞和仓储有限公司</dt>
                            <dd>地址：天津市东丽区新兴村瑞和仓储</dd>
                            <dd>电话&传真：022-24998585</dd>
                        </dl>
                        <dl>
                            <dt>天津市新兴伟业集装箱装卸服务有限公司</dt>
                            <dd>地址：天津市东丽区新兴村合兴路688号</dd>
                            <dd>电话&传真：022-24998585</dd>
                        </dl>

                    </div>

                </div>
            </div>



        </div>

<!--        <van-row gutter="20" style="margin-top:10px">-->
<!--            <van-col span="8" offset="8">-->
<!--                <van-button block size="small" plain type="info" native-type="submit" class="button"-->
<!--                            @click="back()">-->
<!--                    关闭-->
<!--                </van-button>-->
<!--            </van-col>-->
<!--        </van-row>-->







    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                show: true,//nav bar
                list: [],
                loading: true,
                finished: false,
                searchValue: {},
                showPickerNotifySta: false,
                selProcessNotifyStatus: '',
                selProcessName: '',
                showPickerPro: false,
                selMachineName: '',
                showPickerMac: false,
                selMachineDetailName: '',
                showPickerMacD: false,
                selProcesstaskStatus: '',
                showPickerProSta: false,
                date: '',
                processData: [],
                processCol: [],
                machineData: [],
                machineCol: [],
                machineDetailData: [],
                machineDetailCol: [],
                addShowPop: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                taskCount: 0,
                sumWeight: 0,
                notifyCount: 0,
                //详情pop
                detailPop: false,
                detailList: [],
                packageDetailPop:false,
                productDetailPop:false,
                packageList: [],
                packageNo:[]
            }
        },
        mounted() {
            this.onLoad();
            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            service.selProcessG(parm).then(res => {
                let data = res.data;
                this.processData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.processCol.push(data[i].processName)
                }
            })
            service.selMachineNameG(parm).then(res => {
                let data = res.data;
                this.machineData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.machineCol.push(data[i].machineName)
                }
            })
        },

        methods: {
            formatDate(date) {
                return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            onConfirm(date) {
                this.show = false;
                this.date = this.formatDate(date);
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
            },

            onSearch() {
                this.list = [];
                this.page = 1;
                this.show = true;
                this.addShowPop = false;
                this.onLoad();
            },
            onLoad() {
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                setTimeout(() => {
                    for (let i = 0; i < 10; i++) {
                        this.list.push(this.list.length + 1);
                    }

                    // 加载状态结束
                    this.loading = false;

                    // 数据全部加载完成
                    if (this.list.length >= 40) {
                        this.finished = true;
                    }
                }, 1000);
            },
            getDetailList() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = this.page;
                searchObj.size = this.pageSize;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")
                service.selJgProcessnotify(JSON.parse(JSON.stringify(searchObj))).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                })
            },




        }
    }
</script>

<style scoped>


    .searchwarp {
        margin-top: 0px;
        height: calc(100vh - 5px);
        overflow: auto;
    }

    /*/deep/ .van-cell__title {*/
    /*    text-align: left;*/
    /*    -webkit-box-flex: unset;*/
    /*    -webkit-flex: unset;*/
    /*    flex: unset;*/
    /*}*/
    .van-panel__content{
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }
    .searchwarp .van-hairline--top-bottom::after {
        border-width:0;
    }
    .van-panel__content dd{
        margin-inline-start: 0px;
        font-size: 14px;
    }
    .van-panel__content dt{
        font-size: 14px;
        font-weight: bold;
    }
</style>
